import { DEFAULT_STATE } from '@/modules/sale/constants';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const state = {
  ...DEFAULT_STATE,
  user: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
